import axios from 'axios';

/**
 * 获取头部导航菜单
 */
function getHeaderList() {
  var data = {
    parentMenuValue: '/',
    serviceName: window.host.serviceName,
    httpMethod: 'GET',
    parentType: 'FRONTEND_DOMAIN',
    childType: 'FRONTEND_URL'
  }
  return axios.get('platform/v1/resources/granted/submenu?', {params: data})
}

function logout() {
  return axios.get(`auth/user/logout?`)
}

/**
 * 获取字典数据
 */
function getDic() {
  return axios.get(`apply/v1/group/input/dictionaries?`)
}

export default {
  getHeaderList,
  logout,
  getDic
};



// WEBPACK FOOTER //
// ./src/interface.js